import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { PostsService } from './../../services/posts/posts.service';

@Component({
  selector: 'app-last-news-horizontal',
  templateUrl: './last-news-horizontal.component.html',
  styleUrls: ['./last-news-horizontal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LastNewsHorizontalComponent implements OnInit {

  posts: any;

  constructor(
    private postsService: PostsService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.getPosts();
  }

  getPosts() {
    this.postsService.getPost().subscribe((posts) => {
      this.posts = posts;
      this.cdr.markForCheck();
    });
  }

  trackByPost(_: number, post: any) {
    return (post && post.token) || _;
  }

}
